import React from "react";
import Icon, { Icons } from "../Icon/Icon";
import styles from "./Tag.module.css";

export const Colors = {
    mocha: styles.tagMocha,
    velvet: styles.tagVelvet,
    plum: styles.tagPlum,
    mustard: styles.tagMustard,
    mint: styles.tagMint,
    transparent: styles.tagTransparent,
};

export const Sizes = {
    small: styles.tagSmall,
    default: "",
};

interface Props {
    color?: keyof typeof Colors;
    children: React.ReactNode;
    className?: string;
    icon?: Icons;
    size?: keyof typeof Sizes;
}

const Tag = ({ color = "mocha", size = "default", children, icon, className = "" }: Props) => (
    <div className={`${styles.tag} ${Colors[color]} ${Sizes[size]} ${className}`}>
        <span>{children}</span>
        {icon && <Icon icon={icon} />}
    </div>
);

export default Tag;
